/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceIncidentConfigurationMappingForSecurityAlert extends models.FreshserviceIncidentConfigurationMappingBase {
    getFixupPrototypeFunction() { return FreshserviceIncidentConfigurationMappingForSecurityAlert.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceIncidentConfigurationMappingForSecurityAlert>): FreshserviceIncidentConfigurationMappingForSecurityAlert {
        let obj = Object.assign(new FreshserviceIncidentConfigurationMappingForSecurityAlert(), model);
        FreshserviceIncidentConfigurationMappingForSecurityAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceIncidentConfigurationMappingForSecurityAlert>): FreshserviceIncidentConfigurationMappingForSecurityAlert {
        if (!model) return null;
        return FreshserviceIncidentConfigurationMappingForSecurityAlert.newInstance(<FreshserviceIncidentConfigurationMappingForSecurityAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceIncidentConfigurationMappingForSecurityAlert) {
        if (!obj) return;

        models.FreshserviceIncidentConfigurationMappingForSecurityAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceIncidentConfigurationMappingForSecurityAlert): boolean {
        if (models.FreshserviceIncidentConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceIncidentConfigurationMappingForSecurityAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Security Alerts Description
     */
    value: models.DescriptionAttributeForItsmSecurityAlert;

    value_direct: string;

}
